import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      position: 'relative',
      width: '100%',
    };

    this.swiper = {
      overflow: 'visible',
      pb: [3, 4],
    };
  })()
);
